import { render, staticRenderFns } from "./AddEventModal.vue?vue&type=template&id=4c68ddb5&scoped=true&lang=pug"
import script from "./AddEventModal.vue?vue&type=script&lang=js"
export * from "./AddEventModal.vue?vue&type=script&lang=js"
import style0 from "./AddEventModal.vue?vue&type=style&index=0&id=4c68ddb5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c68ddb5",
  null
  
)

export default component.exports